"use client"

import { getPolisDetail, getLpuDetail } from '@/lib/data'
import { useEffect, useState } from 'react';

export function Vipiska({
  ENP, LPU
}) {

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    "FAM":"",
    "IM":"",
    "OT":"",
    "DR":"",
    "WM":"",
    "WW":"",
    "CITIZENSHIP":"",
    "ENP":"",
    "DATESTART":"",
    "SROK":"",
    "SMOCOD":"",
    "NAMESMO":"",
    "OBL":""
  })

  const [LPUdata, setLPUData] = useState({
    "address":"",
    "chief_medical_officer":"",
    "code_mo":"",
    "name":"",
    "phone":"",
    "phone_smp":"",
    "time_work_smp":"",
    "time_work":"",
    "www":"",
    "lng":"",
    "lat":""
  })

  const [src, setSrc] = useState(null)

  useEffect(() => {
    let tk = localStorage.getItem('token')
    getPolisDetail(setLoading, setData, tk, ENP)
    getLpuDetail(setLoading, setLPUData, tk, LPU, setSrc)
  }, []);

  return (
    <div>
      <div className='space-y-3 px-2'>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Фамилия:</div>
          <div className='border-b flex-1'>{data.FAM}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Имя:</div>
          <div className='border-b flex-1'>{data.IM}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Отчество:</div>
          <div className='border-b flex-1'>{data.OT}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Дата рождения:</div>
          <div className='border-b flex-1'>{data.DR}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Пол:</div>
          <div className='flex flex-row flex-1 items-center justify-start space-x-4'>
            <div>муж.</div>
            <div className='border border-black h-6 w-9 text-center'>{data.WM}</div>
            <div>жен.</div>
            <div className='border border-black h-6 w-9 text-center'>{data.WW}</div>
          </div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Гражданство:</div>
          <div className='border-b flex-1'>{data.CITIZENSHIP}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>ЕНП:</div>
          <div className='border-b flex-1'>{data.ENP}</div>
        </div>
        <div className='flex flex-row w-full text-[14px] mt-4'>
          <div className='mx-3'>Срок действия полиса ОМС:</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>- дата начала действия полиса ОМС: {data.DATESTART}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>- <b className='text-[#235396]'>{data.SROK}</b></div>
        </div>
      </div>

      <div className='mb-4 mt-4 font-semibold text-center '>Информация о страховой медицинской организации</div>
      <div className='space-y-3 px-2'>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Реестровый номер:</div>
          <div className='border-b flex-1'>{data.SMOCOD}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Наименование:</div>
          <div className='border-b flex-1'>{data.NAMESMO}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Номер телефона:</div>
          <div className='border-b flex-1'>88001008102</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Субъект РФ:</div>
          <div className='border-b flex-1'>{data.OBL}</div>
        </div>
      </div>

      {LPUdata ? (<>
      <div className='mb-4 mx-4 mt-16 font-semibold text-center'>Информация о прикреплении к МО</div>
      <div className='space-y-3 px-2'>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Название:</div>
          <div className='border-b flex-1'>{LPUdata.name}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Адрес:</div>
          <div className='border-b flex-1'>{LPUdata.address}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Номер телефона:</div>
          <div className='border-b flex-1'>{LPUdata.phone}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Номер телефона СМП:</div>
          <div className='border-b flex-1'>{LPUdata.phone_smp}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Время работы:</div>
          <div className='border-b flex-1'>{LPUdata.time_work}</div>
        </div>
        <div className='flex flex-row w-full text-[14px]'>
          <div className='mx-3'>Главрач:</div>
          <div className='border-b flex-1'>{LPUdata.chief_medical_officer}</div>
        </div>
      </div>

      <iframe className="border border-2 rounded-xl my-4 px-2"
      src={src}
      title='title'
      style={{
        width: '100%',
        height: '250px',
        border: 'none',
      }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    />
        </>
      ) : (null)}
    </div>
  )
}
